import React, { useState } from "react";
import "./ImagingHowItWorks.css";
import GroupImagingHowWorks from "../../Assets/GroupImagingHowWorks.svg";
import GroupImagingHowWorks2 from "../../Assets/Group 11235.png";
import GroupImagingHowWorks3 from "../../Assets/Group 11266.png";


function ImagingHowItWorks() {
  const [buttonState, setButtonState] = useState("");
  const [disable, setDisable] = useState(false);
  const [disable2, setDisable2] = useState(true);
  const [disable3, setDisable3] = useState(true);

  console.log("buttonValue", buttonState);
  const buttonHandler = (e) => {
    setButtonState(e.target.value);
    setDisable(false);
    setDisable2(true);
    setDisable3(true);
  };
  const buttonHandler2 = (e) => {
    setButtonState(e.target.value);
    setDisable2(false);
    setDisable(true);
    setDisable3(true);
  };
  const buttonHandler3 = (e) => {
    setButtonState(e.target.value);
    setDisable3(false);
    setDisable(true);
    setDisable2(true);
  };
  return (
    <div className="ImagingHowItWorksMain">
    <div className="divForImagingHowItWorks container">
      <h1 style={{ marginTop: "2rem" }}>How it works</h1>
      <p>
        Booking imaging appointments is hassle-free with Redcliffe Imaging We
        make sure our patients get the convenient and the best experience in
        booking imaging appointments and getting imaging procedures done at
        affordable prices.
      </p>

      <div className="ImagingHowItWorksStepsDivMain">
        <div className="ImagingHowItWorksStepsButton">
          <button
           className={disable===true ? "disableButtonForHowWorks" : "enableButtonForHowWorks"}
          value="step1" onClick={buttonHandler}>
            STEP 1
          </button>
          <button
            // disabled={disable}
            className={disable2===true ? "disableButtonForHowWorks" : "enableButtonForHowWorks"}
            value="End To End Facilitation"
            onClick={buttonHandler2}
          >
            STEP 2
          </button>
          <button
            //  disabled={disable}
            className={disable3===true ? "disableButtonForHowWorks" : "enableButtonForHowWorks"}
            value="Quality & Timely Reports"
            onClick={buttonHandler3}
          >
            STEP 3
          </button>
        </div>

        {buttonState === "" || buttonState === "step1" ? (
          <div className="Step1ForHowWorks">
            <div className="Step1ForHowWorksImages">
              <img src={GroupImagingHowWorks} alt="GroupImagingHowWorks" />
            </div>
            <div className="Step1ForHowWorksPara">
              <h2>Accessibility & Affordability</h2>
              <p>
              Redcliffe Imaging is your health advisor that strives to provide access to top-notch and advanced radiology services at affordable prices. By keeping the imaging services’ prices cost-effective, we make sure we are not compromising with the quality.
              </p>
            </div>
          </div>
        ) :
        buttonState==="Quality & Timely Reports" ? 
        (
          <div className="Step1ForHowWorks">
            <div className="Step1ForHowWorksImages">
              <img src={GroupImagingHowWorks3} alt="GroupImagingHowWorks" />
            </div>
            <div className="Step1ForHowWorksPara">
              <h2>{buttonState}</h2>
              <p>
              With prioritizing customer service, we endeavor to thrive on quality service and quick turn around time (TAT) in terms of accuracy and reliability in reporting. We aim to provide radiology of the uppermost quality that forms the very foundation of our brand.
              </p>
            </div>
          </div>
        ): (
            <div className="Step1ForHowWorks">
              <div className="Step1ForHowWorksImages">
                <img src={GroupImagingHowWorks2} alt="GroupImagingHowWorks" />
              </div>
              <div className="Step1ForHowWorksPara">
                <h2>{buttonState}</h2>
                <p>
                Our most treasured resources are our experienced and skilled professionals who precisely manage patient study through seamless imaging. While technology hugely supports the services we provide, it’s our pool of professional employees and their hand holding who are behind the scenes ensuring that the services are that of superior experience.
                </p>
              </div>
            </div>
          ) }: 
      </div>
    </div>
    </div>
  );
}

export default ImagingHowItWorks;
